"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
require("core-js/modules/es6.regexp.split.js");
require("core-js/modules/es6.array.map.js");
require("core-js/modules/es6.array.find.js");
var _gAxios = _interopRequireWildcard(require("@gravity/g-axios"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _add_days = _interopRequireDefault(require("date-fns/add_days"));
var _productList = require("@nucleo/product-list");
var _constants = require("./constants");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_1yurfirldh() {
  var path = "/codebuild/output/src3193688389/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/filter/lib/actions.js";
  var hash = "74b27a8a63f9b01f3f3e35c1d4b69260c6be2cd1";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3193688389/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/filter/lib/actions.js",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 28
        },
        end: {
          line: 14,
          column: 2
        }
      },
      "1": {
        start: {
          line: 11,
          column: 37
        },
        end: {
          line: 14,
          column: 1
        }
      },
      "2": {
        start: {
          line: 16,
          column: 29
        },
        end: {
          line: 19,
          column: 2
        }
      },
      "3": {
        start: {
          line: 16,
          column: 38
        },
        end: {
          line: 19,
          column: 1
        }
      },
      "4": {
        start: {
          line: 21,
          column: 29
        },
        end: {
          line: 24,
          column: 2
        }
      },
      "5": {
        start: {
          line: 21,
          column: 38
        },
        end: {
          line: 24,
          column: 1
        }
      },
      "6": {
        start: {
          line: 26,
          column: 27
        },
        end: {
          line: 28,
          column: 2
        }
      },
      "7": {
        start: {
          line: 26,
          column: 34
        },
        end: {
          line: 28,
          column: 1
        }
      },
      "8": {
        start: {
          line: 30,
          column: 28
        },
        end: {
          line: 33,
          column: 2
        }
      },
      "9": {
        start: {
          line: 30,
          column: 43
        },
        end: {
          line: 33,
          column: 1
        }
      },
      "10": {
        start: {
          line: 35,
          column: 39
        },
        end: {
          line: 40,
          column: 2
        }
      },
      "11": {
        start: {
          line: 35,
          column: 70
        },
        end: {
          line: 40,
          column: 1
        }
      },
      "12": {
        start: {
          line: 42,
          column: 51
        },
        end: {
          line: 46,
          column: 2
        }
      },
      "13": {
        start: {
          line: 42,
          column: 70
        },
        end: {
          line: 46,
          column: 1
        }
      },
      "14": {
        start: {
          line: 48,
          column: 17
        },
        end: {
          line: 48,
          column: 50
        }
      },
      "15": {
        start: {
          line: 48,
          column: 27
        },
        end: {
          line: 48,
          column: 50
        }
      },
      "16": {
        start: {
          line: 49,
          column: 23
        },
        end: {
          line: 76,
          column: 1
        }
      },
      "17": {
        start: {
          line: 51,
          column: 2
        },
        end: {
          line: 51,
          column: 53
        }
      },
      "18": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 54,
          column: 101
        }
      },
      "19": {
        start: {
          line: 56,
          column: 2
        },
        end: {
          line: 75,
          column: 7
        }
      },
      "20": {
        start: {
          line: 65,
          column: 6
        },
        end: {
          line: 68,
          column: 7
        }
      },
      "21": {
        start: {
          line: 66,
          column: 8
        },
        end: {
          line: 66,
          column: 89
        }
      },
      "22": {
        start: {
          line: 67,
          column: 8
        },
        end: {
          line: 67,
          column: 29
        }
      },
      "23": {
        start: {
          line: 69,
          column: 6
        },
        end: {
          line: 69,
          column: 21
        }
      },
      "24": {
        start: {
          line: 72,
          column: 6
        },
        end: {
          line: 72,
          column: 37
        }
      },
      "25": {
        start: {
          line: 73,
          column: 6
        },
        end: {
          line: 73,
          column: 102
        }
      },
      "26": {
        start: {
          line: 74,
          column: 6
        },
        end: {
          line: 74,
          column: 22
        }
      },
      "27": {
        start: {
          line: 78,
          column: 21
        },
        end: {
          line: 85,
          column: 4
        }
      },
      "28": {
        start: {
          line: 79,
          column: 2
        },
        end: {
          line: 85,
          column: 4
        }
      },
      "29": {
        start: {
          line: 87,
          column: 21
        },
        end: {
          line: 97,
          column: 1
        }
      },
      "30": {
        start: {
          line: 89,
          column: 18
        },
        end: {
          line: 94,
          column: 5
        }
      },
      "31": {
        start: {
          line: 89,
          column: 41
        },
        end: {
          line: 94,
          column: 3
        }
      },
      "32": {
        start: {
          line: 96,
          column: 2
        },
        end: {
          line: 96,
          column: 75
        }
      },
      "33": {
        start: {
          line: 99,
          column: 21
        },
        end: {
          line: 106,
          column: 4
        }
      },
      "34": {
        start: {
          line: 100,
          column: 2
        },
        end: {
          line: 106,
          column: 4
        }
      },
      "35": {
        start: {
          line: 108,
          column: 35
        },
        end: {
          line: 115,
          column: 4
        }
      },
      "36": {
        start: {
          line: 109,
          column: 2
        },
        end: {
          line: 115,
          column: 4
        }
      },
      "37": {
        start: {
          line: 117,
          column: 22
        },
        end: {
          line: 124,
          column: 4
        }
      },
      "38": {
        start: {
          line: 118,
          column: 2
        },
        end: {
          line: 124,
          column: 4
        }
      },
      "39": {
        start: {
          line: 126,
          column: 22
        },
        end: {
          line: 133,
          column: 4
        }
      },
      "40": {
        start: {
          line: 127,
          column: 2
        },
        end: {
          line: 133,
          column: 4
        }
      },
      "41": {
        start: {
          line: 135,
          column: 32
        },
        end: {
          line: 137,
          column: 2
        }
      },
      "42": {
        start: {
          line: 135,
          column: 39
        },
        end: {
          line: 137,
          column: 1
        }
      },
      "43": {
        start: {
          line: 139,
          column: 33
        },
        end: {
          line: 141,
          column: 2
        }
      },
      "44": {
        start: {
          line: 139,
          column: 40
        },
        end: {
          line: 141,
          column: 1
        }
      },
      "45": {
        start: {
          line: 143,
          column: 43
        },
        end: {
          line: 147,
          column: 2
        }
      },
      "46": {
        start: {
          line: 143,
          column: 62
        },
        end: {
          line: 147,
          column: 1
        }
      },
      "47": {
        start: {
          line: 149,
          column: 29
        },
        end: {
          line: 150,
          column: 106
        }
      },
      "48": {
        start: {
          line: 150,
          column: 4
        },
        end: {
          line: 150,
          column: 106
        }
      },
      "49": {
        start: {
          line: 150,
          column: 34
        },
        end: {
          line: 150,
          column: 105
        }
      },
      "50": {
        start: {
          line: 155,
          column: 23
        },
        end: {
          line: 189,
          column: 1
        }
      },
      "51": {
        start: {
          line: 155,
          column: 61
        },
        end: {
          line: 189,
          column: 1
        }
      },
      "52": {
        start: {
          line: 156,
          column: 24
        },
        end: {
          line: 157,
          column: 62
        }
      },
      "53": {
        start: {
          line: 158,
          column: 2
        },
        end: {
          line: 158,
          column: 47
        }
      },
      "54": {
        start: {
          line: 161,
          column: 2
        },
        end: {
          line: 161,
          column: 82
        }
      },
      "55": {
        start: {
          line: 161,
          column: 45
        },
        end: {
          line: 161,
          column: 80
        }
      },
      "56": {
        start: {
          line: 162,
          column: 2
        },
        end: {
          line: 162,
          column: 34
        }
      },
      "57": {
        start: {
          line: 163,
          column: 2
        },
        end: {
          line: 163,
          column: 34
        }
      },
      "58": {
        start: {
          line: 164,
          column: 2
        },
        end: {
          line: 164,
          column: 33
        }
      },
      "59": {
        start: {
          line: 166,
          column: 2
        },
        end: {
          line: 168,
          column: 3
        }
      },
      "60": {
        start: {
          line: 167,
          column: 4
        },
        end: {
          line: 167,
          column: 41
        }
      },
      "61": {
        start: {
          line: 170,
          column: 2
        },
        end: {
          line: 175,
          column: 3
        }
      },
      "62": {
        start: {
          line: 171,
          column: 4
        },
        end: {
          line: 174,
          column: 7
        }
      },
      "63": {
        start: {
          line: 172,
          column: 32
        },
        end: {
          line: 172,
          column: 85
        }
      },
      "64": {
        start: {
          line: 178,
          column: 23
        },
        end: {
          line: 182,
          column: 3
        }
      },
      "65": {
        start: {
          line: 180,
          column: 6
        },
        end: {
          line: 181,
          column: 56
        }
      },
      "66": {
        start: {
          line: 183,
          column: 2
        },
        end: {
          line: 188,
          column: 3
        }
      },
      "67": {
        start: {
          line: 184,
          column: 4
        },
        end: {
          line: 184,
          column: 49
        }
      },
      "68": {
        start: {
          line: 185,
          column: 4
        },
        end: {
          line: 187,
          column: 5
        }
      },
      "69": {
        start: {
          line: 186,
          column: 6
        },
        end: {
          line: 186,
          column: 42
        }
      },
      "70": {
        start: {
          line: 194,
          column: 14
        },
        end: {
          line: 194,
          column: 70
        }
      },
      "71": {
        start: {
          line: 194,
          column: 22
        },
        end: {
          line: 194,
          column: 70
        }
      },
      "72": {
        start: {
          line: 194,
          column: 34
        },
        end: {
          line: 194,
          column: 70
        }
      },
      "73": {
        start: {
          line: 199,
          column: 14
        },
        end: {
          line: 199,
          column: 70
        }
      },
      "74": {
        start: {
          line: 199,
          column: 22
        },
        end: {
          line: 199,
          column: 70
        }
      },
      "75": {
        start: {
          line: 199,
          column: 34
        },
        end: {
          line: 199,
          column: 70
        }
      },
      "76": {
        start: {
          line: 206,
          column: 18
        },
        end: {
          line: 211,
          column: 1
        }
      },
      "77": {
        start: {
          line: 206,
          column: 40
        },
        end: {
          line: 211,
          column: 1
        }
      },
      "78": {
        start: {
          line: 207,
          column: 25
        },
        end: {
          line: 207,
          column: 65
        }
      },
      "79": {
        start: {
          line: 208,
          column: 23
        },
        end: {
          line: 208,
          column: 73
        }
      },
      "80": {
        start: {
          line: 210,
          column: 2
        },
        end: {
          line: 210,
          column: 85
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 11,
            column: 28
          },
          end: {
            line: 11,
            column: 29
          }
        },
        loc: {
          start: {
            line: 11,
            column: 37
          },
          end: {
            line: 14,
            column: 1
          }
        },
        line: 11
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 16,
            column: 29
          },
          end: {
            line: 16,
            column: 30
          }
        },
        loc: {
          start: {
            line: 16,
            column: 38
          },
          end: {
            line: 19,
            column: 1
          }
        },
        line: 16
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 21,
            column: 29
          },
          end: {
            line: 21,
            column: 30
          }
        },
        loc: {
          start: {
            line: 21,
            column: 38
          },
          end: {
            line: 24,
            column: 1
          }
        },
        line: 21
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 26,
            column: 27
          },
          end: {
            line: 26,
            column: 28
          }
        },
        loc: {
          start: {
            line: 26,
            column: 34
          },
          end: {
            line: 28,
            column: 1
          }
        },
        line: 26
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 30,
            column: 28
          },
          end: {
            line: 30,
            column: 29
          }
        },
        loc: {
          start: {
            line: 30,
            column: 43
          },
          end: {
            line: 33,
            column: 1
          }
        },
        line: 30
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 35,
            column: 39
          },
          end: {
            line: 35,
            column: 40
          }
        },
        loc: {
          start: {
            line: 35,
            column: 70
          },
          end: {
            line: 40,
            column: 1
          }
        },
        line: 35
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 42,
            column: 51
          },
          end: {
            line: 42,
            column: 52
          }
        },
        loc: {
          start: {
            line: 42,
            column: 70
          },
          end: {
            line: 46,
            column: 1
          }
        },
        line: 42
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 48,
            column: 17
          },
          end: {
            line: 48,
            column: 18
          }
        },
        loc: {
          start: {
            line: 48,
            column: 27
          },
          end: {
            line: 48,
            column: 50
          }
        },
        line: 48
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 49,
            column: 23
          },
          end: {
            line: 49,
            column: 24
          }
        },
        loc: {
          start: {
            line: 49,
            column: 96
          },
          end: {
            line: 76,
            column: 1
          }
        },
        line: 49
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 64,
            column: 10
          },
          end: {
            line: 64,
            column: 11
          }
        },
        loc: {
          start: {
            line: 64,
            column: 22
          },
          end: {
            line: 70,
            column: 5
          }
        },
        line: 64
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 71,
            column: 11
          },
          end: {
            line: 71,
            column: 12
          }
        },
        loc: {
          start: {
            line: 71,
            column: 23
          },
          end: {
            line: 75,
            column: 5
          }
        },
        line: 71
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 78,
            column: 21
          },
          end: {
            line: 78,
            column: 22
          }
        },
        loc: {
          start: {
            line: 79,
            column: 2
          },
          end: {
            line: 85,
            column: 4
          }
        },
        line: 79
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 87,
            column: 21
          },
          end: {
            line: 87,
            column: 22
          }
        },
        loc: {
          start: {
            line: 87,
            column: 48
          },
          end: {
            line: 97,
            column: 1
          }
        },
        line: 87
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 89,
            column: 32
          },
          end: {
            line: 89,
            column: 33
          }
        },
        loc: {
          start: {
            line: 89,
            column: 41
          },
          end: {
            line: 94,
            column: 3
          }
        },
        line: 89
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 99,
            column: 21
          },
          end: {
            line: 99,
            column: 22
          }
        },
        loc: {
          start: {
            line: 100,
            column: 2
          },
          end: {
            line: 106,
            column: 4
          }
        },
        line: 100
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 108,
            column: 35
          },
          end: {
            line: 108,
            column: 36
          }
        },
        loc: {
          start: {
            line: 109,
            column: 2
          },
          end: {
            line: 115,
            column: 4
          }
        },
        line: 109
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 117,
            column: 22
          },
          end: {
            line: 117,
            column: 23
          }
        },
        loc: {
          start: {
            line: 118,
            column: 2
          },
          end: {
            line: 124,
            column: 4
          }
        },
        line: 118
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 126,
            column: 22
          },
          end: {
            line: 126,
            column: 23
          }
        },
        loc: {
          start: {
            line: 127,
            column: 2
          },
          end: {
            line: 133,
            column: 4
          }
        },
        line: 127
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 135,
            column: 32
          },
          end: {
            line: 135,
            column: 33
          }
        },
        loc: {
          start: {
            line: 135,
            column: 39
          },
          end: {
            line: 137,
            column: 1
          }
        },
        line: 135
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 139,
            column: 33
          },
          end: {
            line: 139,
            column: 34
          }
        },
        loc: {
          start: {
            line: 139,
            column: 40
          },
          end: {
            line: 141,
            column: 1
          }
        },
        line: 139
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 143,
            column: 43
          },
          end: {
            line: 143,
            column: 44
          }
        },
        loc: {
          start: {
            line: 143,
            column: 62
          },
          end: {
            line: 147,
            column: 1
          }
        },
        line: 143
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 149,
            column: 29
          },
          end: {
            line: 149,
            column: 30
          }
        },
        loc: {
          start: {
            line: 150,
            column: 4
          },
          end: {
            line: 150,
            column: 106
          }
        },
        line: 150
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 150,
            column: 23
          },
          end: {
            line: 150,
            column: 24
          }
        },
        loc: {
          start: {
            line: 150,
            column: 34
          },
          end: {
            line: 150,
            column: 105
          }
        },
        line: 150
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 155,
            column: 23
          },
          end: {
            line: 155,
            column: 24
          }
        },
        loc: {
          start: {
            line: 155,
            column: 61
          },
          end: {
            line: 189,
            column: 1
          }
        },
        line: 155
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 155,
            column: 61
          },
          end: {
            line: 155,
            column: 62
          }
        },
        loc: {
          start: {
            line: 155,
            column: 73
          },
          end: {
            line: 189,
            column: 1
          }
        },
        line: 155
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 161,
            column: 38
          },
          end: {
            line: 161,
            column: 39
          }
        },
        loc: {
          start: {
            line: 161,
            column: 45
          },
          end: {
            line: 161,
            column: 80
          }
        },
        line: 161
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 172,
            column: 24
          },
          end: {
            line: 172,
            column: 25
          }
        },
        loc: {
          start: {
            line: 172,
            column: 32
          },
          end: {
            line: 172,
            column: 85
          }
        },
        line: 172
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 179,
            column: 4
          },
          end: {
            line: 179,
            column: 5
          }
        },
        loc: {
          start: {
            line: 180,
            column: 6
          },
          end: {
            line: 181,
            column: 56
          }
        },
        line: 180
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 194,
            column: 14
          },
          end: {
            line: 194,
            column: 15
          }
        },
        loc: {
          start: {
            line: 194,
            column: 22
          },
          end: {
            line: 194,
            column: 70
          }
        },
        line: 194
      },
      "29": {
        name: "(anonymous_29)",
        decl: {
          start: {
            line: 194,
            column: 22
          },
          end: {
            line: 194,
            column: 23
          }
        },
        loc: {
          start: {
            line: 194,
            column: 34
          },
          end: {
            line: 194,
            column: 70
          }
        },
        line: 194
      },
      "30": {
        name: "(anonymous_30)",
        decl: {
          start: {
            line: 199,
            column: 14
          },
          end: {
            line: 199,
            column: 15
          }
        },
        loc: {
          start: {
            line: 199,
            column: 22
          },
          end: {
            line: 199,
            column: 70
          }
        },
        line: 199
      },
      "31": {
        name: "(anonymous_31)",
        decl: {
          start: {
            line: 199,
            column: 22
          },
          end: {
            line: 199,
            column: 23
          }
        },
        loc: {
          start: {
            line: 199,
            column: 34
          },
          end: {
            line: 199,
            column: 70
          }
        },
        line: 199
      },
      "32": {
        name: "(anonymous_32)",
        decl: {
          start: {
            line: 206,
            column: 18
          },
          end: {
            line: 206,
            column: 19
          }
        },
        loc: {
          start: {
            line: 206,
            column: 40
          },
          end: {
            line: 211,
            column: 1
          }
        },
        line: 206
      },
      "33": {
        name: "(anonymous_33)",
        decl: {
          start: {
            line: 206,
            column: 40
          },
          end: {
            line: 206,
            column: 41
          }
        },
        loc: {
          start: {
            line: 206,
            column: 52
          },
          end: {
            line: 211,
            column: 1
          }
        },
        line: 206
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 54,
            column: 101
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 54,
            column: 53
          },
          end: {
            line: 54,
            column: 63
          }
        }, {
          start: {
            line: 54,
            column: 66
          },
          end: {
            line: 54,
            column: 101
          }
        }],
        line: 54
      },
      "1": {
        loc: {
          start: {
            line: 58,
            column: 6
          },
          end: {
            line: 58,
            column: 89
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 58,
            column: 34
          },
          end: {
            line: 58,
            column: 84
          }
        }, {
          start: {
            line: 58,
            column: 87
          },
          end: {
            line: 58,
            column: 89
          }
        }],
        line: 58
      },
      "2": {
        loc: {
          start: {
            line: 65,
            column: 6
          },
          end: {
            line: 68,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 65,
            column: 6
          },
          end: {
            line: 68,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 65
      },
      "3": {
        loc: {
          start: {
            line: 65,
            column: 10
          },
          end: {
            line: 65,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 65,
            column: 10
          },
          end: {
            line: 65,
            column: 32
          }
        }, {
          start: {
            line: 65,
            column: 36
          },
          end: {
            line: 65,
            column: 57
          }
        }],
        line: 65
      },
      "4": {
        loc: {
          start: {
            line: 83,
            column: 27
          },
          end: {
            line: 83,
            column: 89
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 83,
            column: 75
          },
          end: {
            line: 83,
            column: 84
          }
        }, {
          start: {
            line: 83,
            column: 87
          },
          end: {
            line: 83,
            column: 89
          }
        }],
        line: 83
      },
      "5": {
        loc: {
          start: {
            line: 83,
            column: 27
          },
          end: {
            line: 83,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 83,
            column: 27
          },
          end: {
            line: 83,
            column: 40
          }
        }, {
          start: {
            line: 83,
            column: 44
          },
          end: {
            line: 83,
            column: 72
          }
        }],
        line: 83
      },
      "6": {
        loc: {
          start: {
            line: 104,
            column: 27
          },
          end: {
            line: 104,
            column: 89
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 104,
            column: 75
          },
          end: {
            line: 104,
            column: 84
          }
        }, {
          start: {
            line: 104,
            column: 87
          },
          end: {
            line: 104,
            column: 89
          }
        }],
        line: 104
      },
      "7": {
        loc: {
          start: {
            line: 104,
            column: 27
          },
          end: {
            line: 104,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 104,
            column: 27
          },
          end: {
            line: 104,
            column: 40
          }
        }, {
          start: {
            line: 104,
            column: 44
          },
          end: {
            line: 104,
            column: 72
          }
        }],
        line: 104
      },
      "8": {
        loc: {
          start: {
            line: 122,
            column: 27
          },
          end: {
            line: 122,
            column: 89
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 122,
            column: 75
          },
          end: {
            line: 122,
            column: 84
          }
        }, {
          start: {
            line: 122,
            column: 87
          },
          end: {
            line: 122,
            column: 89
          }
        }],
        line: 122
      },
      "9": {
        loc: {
          start: {
            line: 122,
            column: 27
          },
          end: {
            line: 122,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 122,
            column: 27
          },
          end: {
            line: 122,
            column: 40
          }
        }, {
          start: {
            line: 122,
            column: 44
          },
          end: {
            line: 122,
            column: 72
          }
        }],
        line: 122
      },
      "10": {
        loc: {
          start: {
            line: 131,
            column: 27
          },
          end: {
            line: 131,
            column: 89
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 131,
            column: 75
          },
          end: {
            line: 131,
            column: 84
          }
        }, {
          start: {
            line: 131,
            column: 87
          },
          end: {
            line: 131,
            column: 89
          }
        }],
        line: 131
      },
      "11": {
        loc: {
          start: {
            line: 131,
            column: 27
          },
          end: {
            line: 131,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 131,
            column: 27
          },
          end: {
            line: 131,
            column: 40
          }
        }, {
          start: {
            line: 131,
            column: 44
          },
          end: {
            line: 131,
            column: 72
          }
        }],
        line: 131
      },
      "12": {
        loc: {
          start: {
            line: 150,
            column: 34
          },
          end: {
            line: 150,
            column: 105
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 150,
            column: 34
          },
          end: {
            line: 150,
            column: 52
          }
        }, {
          start: {
            line: 150,
            column: 56
          },
          end: {
            line: 150,
            column: 74
          }
        }, {
          start: {
            line: 150,
            column: 78
          },
          end: {
            line: 150,
            column: 105
          }
        }],
        line: 150
      },
      "13": {
        loc: {
          start: {
            line: 166,
            column: 2
          },
          end: {
            line: 168,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 166,
            column: 2
          },
          end: {
            line: 168,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 166
      },
      "14": {
        loc: {
          start: {
            line: 170,
            column: 2
          },
          end: {
            line: 175,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 170,
            column: 2
          },
          end: {
            line: 175,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 170
      },
      "15": {
        loc: {
          start: {
            line: 180,
            column: 6
          },
          end: {
            line: 181,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 180,
            column: 6
          },
          end: {
            line: 180,
            column: 49
          }
        }, {
          start: {
            line: 181,
            column: 6
          },
          end: {
            line: 181,
            column: 56
          }
        }],
        line: 180
      },
      "16": {
        loc: {
          start: {
            line: 183,
            column: 2
          },
          end: {
            line: 188,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 183,
            column: 2
          },
          end: {
            line: 188,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 183
      },
      "17": {
        loc: {
          start: {
            line: 185,
            column: 4
          },
          end: {
            line: 187,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 185,
            column: 4
          },
          end: {
            line: 187,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 185
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "74b27a8a63f9b01f3f3e35c1d4b69260c6be2cd1"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1yurfirldh = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1yurfirldh();
/**
 * Currently, the filter get data locally
 */
cov_1yurfirldh().s[0]++;
var getInitFilterAction = function getInitFilterAction(data) {
  cov_1yurfirldh().f[0]++;
  cov_1yurfirldh().s[1]++;
  return {
    type: _constants.FilterActionType.FILTER_INITIALIZATION,
    data: data
  };
};
cov_1yurfirldh().s[2]++;
var getFilterApplyAction = function getFilterApplyAction(data) {
  cov_1yurfirldh().f[1]++;
  cov_1yurfirldh().s[3]++;
  return {
    type: _constants.FilterActionType.FILTER_APPLY,
    data: data
  };
};
cov_1yurfirldh().s[4]++;
var getFilterResetAction = function getFilterResetAction(data) {
  cov_1yurfirldh().f[2]++;
  cov_1yurfirldh().s[5]++;
  return {
    type: _constants.FilterActionType.FILTER_RESET,
    data: data
  };
};
cov_1yurfirldh().s[6]++;
var getLoadErrorAction = function getLoadErrorAction() {
  cov_1yurfirldh().f[3]++;
  cov_1yurfirldh().s[7]++;
  return {
    type: _constants.FilterActionType.FILTER_LOAD_DATA_ERROR
  };
};
cov_1yurfirldh().s[8]++;
var getBeforeLoadAction = function getBeforeLoadAction(filterCode) {
  cov_1yurfirldh().f[4]++;
  cov_1yurfirldh().s[9]++;
  return {
    type: _constants.FilterActionType.FILTER_BAR_BEFORE_LOAD_DATA,
    filterCode: filterCode
  };
};
cov_1yurfirldh().s[10]++;
var getLoadFilterDataSuccessAction = function getLoadFilterDataSuccessAction(data, config, filterName) {
  cov_1yurfirldh().f[5]++;
  cov_1yurfirldh().s[11]++;
  return {
    type: _constants.FilterActionType.FILTER_LOAD_DATA_SUCCESS,
    data: data,
    config: config,
    filterName: filterName
  };
};
cov_1yurfirldh().s[12]++;
var getLoadHospitalitySessionDataSuccessAction = function getLoadHospitalitySessionDataSuccessAction(data, config) {
  cov_1yurfirldh().f[6]++;
  cov_1yurfirldh().s[13]++;
  return {
    type: _constants.FilterActionType.FILTER_BAR_LOAD_HOSPITALITY_SESSION_DATA_SUCCESS,
    data: data,
    config: config
  };
};
cov_1yurfirldh().s[14]++;
var BASE_URL = function BASE_URL(config) {
  cov_1yurfirldh().f[7]++;
  cov_1yurfirldh().s[15]++;
  return "".concat(config.restHost, "/v1");
};
cov_1yurfirldh().s[16]++;
var loadFilterData = function loadFilterData(_ref) {
  var config = _ref.config,
    dispatch = _ref.dispatch,
    filterName = _ref.filterName,
    filterEndPointName = _ref.filterEndPointName,
    successAction = _ref.successAction;
  cov_1yurfirldh().f[8]++;
  cov_1yurfirldh().s[17]++;
  // first dispatch the beforeLoad action
  dispatch(getBeforeLoadAction("".concat(filterName, "Data")));
  // special case for hospitality sessions's response data
  var responseDataKey = (cov_1yurfirldh().s[18]++, filterName === _constants.FilterField.HOSPITALITY_SESSION ? (cov_1yurfirldh().b[0][0]++, filterName) : (cov_1yurfirldh().b[0][1]++, filterEndPointName.split('/').pop()));
  cov_1yurfirldh().s[19]++;
  return (0, _gAxios.default)("".concat(BASE_URL(config), "/").concat(filterEndPointName).concat(config.productOwnerNumber ? (cov_1yurfirldh().b[1][0]++, "?productOwnerNumber=".concat(config.productOwnerNumber)) : (cov_1yurfirldh().b[1][1]++, '')), {
    headers: config.headers
  }).then(function (response) {
    cov_1yurfirldh().f[9]++;
    cov_1yurfirldh().s[20]++;
    if ((cov_1yurfirldh().b[3][0]++, response.status >= 200) && (cov_1yurfirldh().b[3][1]++, response.status < 300)) {
      cov_1yurfirldh().b[2][0]++;
      cov_1yurfirldh().s[21]++;
      dispatch(successAction(response.data["".concat(responseDataKey)], config, filterName));
      cov_1yurfirldh().s[22]++;
      return response.data;
    } else {
      cov_1yurfirldh().b[2][1]++;
    }
    cov_1yurfirldh().s[23]++;
    throw response;
  }).catch(function (response) {
    cov_1yurfirldh().f[10]++;
    cov_1yurfirldh().s[24]++;
    dispatch(getLoadErrorAction());
    cov_1yurfirldh().s[25]++;
    (0, _gAxios.logError)((0, _gAxios.getFrontEndErrorFromAxiosError)(response), config.headers, config.widgetInfo, response);
    cov_1yurfirldh().s[26]++;
    return response;
  });
};
cov_1yurfirldh().s[27]++;
var loadSiteData = function loadSiteData(config, dispatch) {
  cov_1yurfirldh().f[11]++;
  cov_1yurfirldh().s[28]++;
  return loadFilterData({
    config: config,
    dispatch: dispatch,
    filterName: 'site',
    filterEndPointName: "".concat((cov_1yurfirldh().b[5][0]++, config.config) && (cov_1yurfirldh().b[5][1]++, config.config.cfcacheEnabled) ? (cov_1yurfirldh().b[4][0]++, 'secure/') : (cov_1yurfirldh().b[4][1]++, ''), "sites"),
    successAction: getLoadFilterDataSuccessAction
  });
};
cov_1yurfirldh().s[29]++;
var loadCityData = function loadCityData(res, config, dispatch) {
  cov_1yurfirldh().f[12]++;
  // Get address of each site to build filter city.
  var address = (cov_1yurfirldh().s[30]++, res.sites.map(function (site) {
    cov_1yurfirldh().f[13]++;
    cov_1yurfirldh().s[31]++;
    return {
      id: String(site.address.zipCode),
      name: (0, _defineProperty2.default)({}, config.defaultLanguage, site.address.place)
    };
  }));
  cov_1yurfirldh().s[32]++;
  return dispatch(getLoadFilterDataSuccessAction(address, config, "city"));
};
cov_1yurfirldh().s[33]++;
var loadTeamData = function loadTeamData(config, dispatch) {
  cov_1yurfirldh().f[14]++;
  cov_1yurfirldh().s[34]++;
  return loadFilterData({
    config: config,
    dispatch: dispatch,
    filterName: 'team',
    filterEndPointName: "".concat((cov_1yurfirldh().b[7][0]++, config.config) && (cov_1yurfirldh().b[7][1]++, config.config.cfcacheEnabled) ? (cov_1yurfirldh().b[6][0]++, 'secure/') : (cov_1yurfirldh().b[6][1]++, ''), "teams"),
    successAction: getLoadFilterDataSuccessAction
  });
};
cov_1yurfirldh().s[35]++;
var loadHospitalitySessionData = function loadHospitalitySessionData(config, dispatch) {
  cov_1yurfirldh().f[15]++;
  cov_1yurfirldh().s[36]++;
  return loadFilterData({
    config: config,
    dispatch: dispatch,
    filterName: _constants.FilterField.HOSPITALITY_SESSION,
    filterEndPointName: 'hospitality-sessions',
    successAction: getLoadHospitalitySessionDataSuccessAction
  });
};
cov_1yurfirldh().s[37]++;
var loadSpaceData = function loadSpaceData(config, dispatch) {
  cov_1yurfirldh().f[16]++;
  cov_1yurfirldh().s[38]++;
  return loadFilterData({
    config: config,
    dispatch: dispatch,
    filterName: 'space',
    filterEndPointName: "".concat((cov_1yurfirldh().b[9][0]++, config.config) && (cov_1yurfirldh().b[9][1]++, config.config.cfcacheEnabled) ? (cov_1yurfirldh().b[8][0]++, 'secure/') : (cov_1yurfirldh().b[8][1]++, ''), "spaces"),
    successAction: getLoadFilterDataSuccessAction
  });
};
cov_1yurfirldh().s[39]++;
var loadTopicData = function loadTopicData(config, dispatch) {
  cov_1yurfirldh().f[17]++;
  cov_1yurfirldh().s[40]++;
  return loadFilterData({
    config: config,
    dispatch: dispatch,
    filterName: 'topic',
    filterEndPointName: "".concat((cov_1yurfirldh().b[11][0]++, config.config) && (cov_1yurfirldh().b[11][1]++, config.config.cfcacheEnabled) ? (cov_1yurfirldh().b[10][0]++, 'secure/') : (cov_1yurfirldh().b[10][1]++, ''), "topics"),
    successAction: getLoadFilterDataSuccessAction
  });
};
cov_1yurfirldh().s[41]++;
var loadHospitalityTypeData = function loadHospitalityTypeData() {
  cov_1yurfirldh().f[18]++;
  cov_1yurfirldh().s[42]++;
  return {
    type: _constants.FilterActionType.FILTER_BAR_LOAD_HOSPITALITY_TYPE_SUCCESS
  };
};
cov_1yurfirldh().s[43]++;
var loadOrderProductTypeData = function loadOrderProductTypeData() {
  cov_1yurfirldh().f[19]++;
  cov_1yurfirldh().s[44]++;
  return {
    type: _constants.FilterActionType.FILTER_BAR_LOAD_ODER_PRODUCT_TYPE_SUCCESS
  };
};
cov_1yurfirldh().s[45]++;
var loadCustomProductTypesByProductTab = function loadCustomProductTypesByProductTab(data, config) {
  cov_1yurfirldh().f[20]++;
  cov_1yurfirldh().s[46]++;
  return {
    type: _constants.FilterActionType.FILTER_BAR_LOAD_PRODUCT_TYPES_SUCCESS,
    customProductTypeByProductTab: data,
    config: config
  };
};
cov_1yurfirldh().s[47]++;
var checkIfFilterExisted = function checkIfFilterExisted(availableTabs, filterName) {
  cov_1yurfirldh().f[21]++;
  cov_1yurfirldh().s[48]++;
  return availableTabs.some(function (element) {
    cov_1yurfirldh().f[22]++;
    cov_1yurfirldh().s[49]++;
    return (cov_1yurfirldh().b[12][0]++, element.arrFilters) && (cov_1yurfirldh().b[12][1]++, element.arrFilters) || (cov_1yurfirldh().b[12][2]++, [].indexOf(filterName) >= 0);
  });
};

/*
 * Set/load the basic data for filters
 */
cov_1yurfirldh().s[50]++;
var initFilterData = function initFilterData(tabCodes, catalogSummary, config) {
  cov_1yurfirldh().f[23]++;
  cov_1yurfirldh().s[51]++;
  return function (dispatch) {
    cov_1yurfirldh().f[24]++;
    var availableTabs = (cov_1yurfirldh().s[52]++, _productList.ProductTabModel.get(tabCodes, catalogSummary, !config.isReportContext, config.isFilterProductTypeEnable));
    cov_1yurfirldh().s[53]++;
    dispatch(getInitFilterAction(availableTabs));

    // PTE TODO: move to outside @nucleo/filter
    cov_1yurfirldh().s[54]++;
    loadSiteData(config, dispatch).then(function (res) {
      cov_1yurfirldh().f[25]++;
      cov_1yurfirldh().s[55]++;
      return loadCityData(res, config, dispatch);
    });
    cov_1yurfirldh().s[56]++;
    loadTopicData(config, dispatch);
    cov_1yurfirldh().s[57]++;
    loadSpaceData(config, dispatch);
    cov_1yurfirldh().s[58]++;
    loadTeamData(config, dispatch);
    cov_1yurfirldh().s[59]++;
    if (checkIfFilterExisted(availableTabs, _constants.FilterField.ORDER_PRODUCT_BY)) {
      cov_1yurfirldh().b[13][0]++;
      cov_1yurfirldh().s[60]++;
      dispatch(loadOrderProductTypeData());
    } else {
      cov_1yurfirldh().b[13][1]++;
    }
    // Build data for filter PRODUCT TYPES
    cov_1yurfirldh().s[61]++;
    if (checkIfFilterExisted(availableTabs, _constants.FilterField.PRODUCT_TYPES)) {
      cov_1yurfirldh().b[14][0]++;
      cov_1yurfirldh().s[62]++;
      dispatch(loadCustomProductTypesByProductTab(availableTabs.map(function (tab) {
        cov_1yurfirldh().f[26]++;
        cov_1yurfirldh().s[63]++;
        return {
          "code": tab.code,
          "productTypes": tab.productTypes
        };
      }), config));
    } else {
      cov_1yurfirldh().b[14][1]++;
    }

    // Check if tabs contain Hospitality || Hospitality Bundle before try to get data from server
    var existHospTab = (cov_1yurfirldh().s[64]++, availableTabs.find(function (element) {
      cov_1yurfirldh().f[27]++;
      cov_1yurfirldh().s[65]++;
      return (cov_1yurfirldh().b[15][0]++, element.code === _productList.ProductTabEnum.HOSPITALITY) || (cov_1yurfirldh().b[15][1]++, element.code === _productList.ProductTabEnum.HOSPITALITY_BUNDLE);
    }));
    cov_1yurfirldh().s[66]++;
    if (existHospTab) {
      cov_1yurfirldh().b[16][0]++;
      cov_1yurfirldh().s[67]++;
      loadHospitalitySessionData(config, dispatch);
      cov_1yurfirldh().s[68]++;
      if (checkIfFilterExisted(availableTabs, _constants.FilterField.HOSPITALITY_TYPE)) {
        cov_1yurfirldh().b[17][0]++;
        cov_1yurfirldh().s[69]++;
        dispatch(loadHospitalityTypeData());
      } else {
        cov_1yurfirldh().b[17][1]++;
      }
    } else {
      cov_1yurfirldh().b[16][1]++;
    }
  };
};

/*
 * Update filter data with new filter values
 */
cov_1yurfirldh().s[70]++;
var apply = function apply(data) {
  cov_1yurfirldh().f[28]++;
  cov_1yurfirldh().s[71]++;
  return function (dispatch) {
    cov_1yurfirldh().f[29]++;
    cov_1yurfirldh().s[72]++;
    return dispatch(getFilterApplyAction(data));
  };
};

/*
 * reset filter data
 */
cov_1yurfirldh().s[73]++;
var reset = function reset(data) {
  cov_1yurfirldh().f[30]++;
  cov_1yurfirldh().s[74]++;
  return function (dispatch) {
    cov_1yurfirldh().f[31]++;
    cov_1yurfirldh().s[75]++;
    return dispatch(getFilterResetAction(data));
  };
};

/**
 * Action to change the dateFrom and dateTo, with the same date
 * @param {String} dateFrom, initial date selected
 * @param {String} dateTo, last date selected
 */
cov_1yurfirldh().s[76]++;
var changeDay = function changeDay(dateFrom, dateTo) {
  cov_1yurfirldh().f[32]++;
  cov_1yurfirldh().s[77]++;
  return function (dispatch) {
    cov_1yurfirldh().f[33]++;
    var formatFromDate = (cov_1yurfirldh().s[78]++, (0, _format.default)(new Date(dateFrom), 'YYYY-MM-DD'));
    var formatToDate = (cov_1yurfirldh().s[79]++, (0, _format.default)((0, _add_days.default)(new Date(dateTo), 1), 'YYYY-MM-DD'));
    cov_1yurfirldh().s[80]++;
    dispatch(getFilterApplyAction({
      dateFrom: formatFromDate,
      dateTo: formatToDate
    }));
  };
};
var _default = exports.default = {
  initFilterData: initFilterData,
  apply: apply,
  reset: reset,
  changeDay: changeDay
};